export default "__VITE_ASSET__c8ecae26__"